import React, { useEffect } from 'react'
import { Benefits, DevBanner, FAQ, HowTo, Stories, WhyChoose } from '../../../components'
import { achiveData, FAQData, headerData, HowToData, partnerData, whyChooseData } from './data'

const Automation = () => {

    useEffect(() => {

        window.scrollTo(0, 0)

    }, [])

    return (

        <div className='pt-[70px]'>
            <div className='dark:bg-gray-900 transition-all duration-700'>
                <DevBanner data={headerData} />
            </div>
            <div className='bg-gray-50 dark:bg-slate-800 transition-all duration-700'>
                <Benefits data={achiveData} devServices={true} sucessDriven={true} />
            </div>
            <div className='dark:bg-gray-900 transition-all duration-700'>
                <WhyChoose data={whyChooseData} />
            </div>
            <div className='bg-gray-50 dark:bg-slate-800 transition-all duration-700'>
                <Benefits data={partnerData} />
            </div>
            <div className='dark:bg-gray-900 transition-all duration-700'>
                <HowTo data={HowToData} />
            </div>
            <div className='bg-gray-50 dark:bg-slate-800 transition-all duration-700'>
                <Stories />
            </div>
            <div className='dark:bg-gray-900 transition-all duration-700'>
                <FAQ data={FAQData} />
            </div>

        </div>
    )
}

export default Automation